var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissedcallIncoming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.334,
    height: 9.334,
    viewBox: "0 0 9.334 9.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ef0f0f",
    d: "M9.192.142a.483.483,0,0,0-.684,0L.97,7.677V3.534A.5.5,0,0,0,.558,3.04.485.485,0,0,0,0,3.52v5.33a.486.486,0,0,0,.485.484H5.319a.5.5,0,0,0,.495-.412.485.485,0,0,0-.48-.557H1.653L9.192.83A.488.488,0,0,0,9.192.142Z",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissedcallIncoming);
export default __webpack_public_path__ + "static/media/missedcall-incoming.a2299430.svg";
export { ForwardRef as ReactComponent };